import api from '@/api'

const base = '/painel/ia/playground'

export function listarPipelines(treinamentoId) {
  return api.get(`${base}/pipelines`, {
    params: treinamentoId ? { treinamento_id: treinamentoId } : {},
  })
}

export function listarConversas(treinamentoId) {
  return api.get(`${base}/treinamento/${treinamentoId}/conversas`)
}

export function criarConversa(treinamentoId, payload) {
  return api.post(`${base}/treinamento/${treinamentoId}/conversas`, payload)
}

export function excluirConversa(conversaId) {
  return api.delete(`${base}/conversas/${conversaId}`)
}

export function listarMensagens(conversaId) {
  return api.get(`${base}/conversas/${conversaId}/mensagens`)
}

export function enviarMensagem(conversaId, mensagem) {
  return api.post(`${base}/conversas/${conversaId}/mensagens`, { mensagem })
}

export function enviarMensagemMidia(conversaId, arquivo) {
  const formData = new FormData()
  formData.append('arquivo', arquivo)

  return api.post(`${base}/conversas/${conversaId}/mensagens`, formData)
}

export function excluirMensagem(mensagemId) {
  return api.delete(`${base}/mensagens/${mensagemId}`)
}
